/* ArteTrofeo · motor del creador v2: GPX, km y D+, encuadre (centro, ancho, giro) y mapa con relieve sombreado. */
(() => {
  if (window.ATMapa && window.ATMapa.v >= 3) return;
  const R = 6378137, rad = (d) => d * Math.PI / 180, deg = (r) => r * 180 / Math.PI;
  const hav = (a, b) => { const dLa = rad(b[0] - a[0]), dLo = rad(b[1] - a[1]); const s = Math.sin(dLa / 2) ** 2 + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLo / 2) ** 2; return 2 * R * Math.asin(Math.min(1, Math.sqrt(s))); };
  const merc = (lat, lon) => { const s = Math.sin(rad(Math.max(-85, Math.min(85, lat)))); return [(lon + 180) / 360, 0.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI)]; };
  const inv = (x, y) => [deg(Math.atan(Math.sinh(Math.PI * (1 - 2 * y)))), x * 360 - 180];
  const proy = (pts) => pts.map((p) => merc(p[0], p[1]));

  const parseGPX = (txt) => {
    const doc = new DOMParser().parseFromString(txt, 'application/xml');
    if (doc.getElementsByTagName('parsererror').length) throw new Error('xml');
    let nodes = [...doc.getElementsByTagName('trkpt')];
    if (nodes.length < 2) nodes = [...doc.getElementsByTagName('rtept')];
    const pts = [];
    for (const n of nodes) {
      const lat = parseFloat(n.getAttribute('lat')), lon = parseFloat(n.getAttribute('lon'));
      if (!isFinite(lat) || !isFinite(lon)) continue;
      const e = n.getElementsByTagName('ele')[0];
      pts.push([lat, lon, e ? parseFloat(e.textContent) : NaN]);
    }
    if (pts.length < 2) throw new Error('vacio');
    return { pts };
  };

  /* km y D+ con el mismo cálculo que la app de taller (suavizado ±4 puntos y umbral de 2 m) */
  const stats = (pts) => {
    let d = 0;
    const hv = (a, b) => hav(a, b) * 6371008.8 / R;
    for (let i = 1; i < pts.length; i++) d += hv(pts[i - 1], pts[i]);
    let up = null;
    if (pts.length > 10 && pts.every((p) => isFinite(p[2]))) {
      up = 0;
      const sm = pts.map((_, i) => { let s = 0, c = 0; for (let j = Math.max(0, i - 4); j <= Math.min(pts.length - 1, i + 4); j++) { s += pts[j][2]; c++; } return s / c; });
      let ref = sm[0];
      for (const e of sm) { if (e > ref + 2) { up += e - ref; ref = e; } else if (e < ref - 2) ref = e; }
    }
    return { km: d / 1000, dmas: up };
  };

  const simplify = (pts, tolM) => {
    if (pts.length < 3) return pts.slice();
    const P = proy(pts), tol = tolM / (2 * Math.PI * R * Math.cos(rad(pts[0][0])));
    const keep = new Uint8Array(pts.length); keep[0] = keep[pts.length - 1] = 1;
    const st = [[0, pts.length - 1]];
    while (st.length) {
      const [a, b] = st.pop(); const [ax, ay] = P[a], [bx, by] = P[b]; const dx = bx - ax, dy = by - ay, L = dx * dx + dy * dy;
      let md = 0, mi = -1;
      for (let i = a + 1; i < b; i++) {
        const [px, py] = P[i]; let t = L ? ((px - ax) * dx + (py - ay) * dy) / L : 0; t = Math.max(0, Math.min(1, t));
        const ex = ax + t * dx - px, ey = ay + t * dy - py, dd = ex * ex + ey * ey;
        if (dd > md) { md = dd; mi = i; }
      }
      if (mi > 0 && md > tol * tol) { keep[mi] = 1; st.push([a, mi], [mi, b]); }
    }
    return pts.filter((_, i) => keep[i]);
  };

  const encode = (pts) => {
    let out = '', pl = 0, pg = 0;
    const enc = (v) => { v = v < 0 ? ~(v << 1) : v << 1; let s = ''; while (v >= 0x20) { s += String.fromCharCode((0x20 | (v & 0x1f)) + 63); v >>= 5; } return s + String.fromCharCode(v + 63); };
    for (const p of pts) { const la = Math.round(p[0] * 1e5), lo = Math.round(p[1] * 1e5); out += enc(la - pl) + enc(lo - pg); pl = la; pg = lo; }
    return out;
  };

  /* Encuadre: centro (cx, cy en Mercator 0-1), ancho w del marco y giro ang en grados (positivo = antihorario).
     Prueba norte arriba o tumbada 90° en un marco horizontal de proporción A; gira solo si llena >12 % más. */
  const mejorVista = (pts, A, pad = 0.08) => {
    const P = proy(pts);
    let cx = 0, cy = 0;
    for (const [x, y] of P) { cx += x; cy += y; }
    cx /= P.length; cy /= P.length;
    let best = null;
    for (const d of [0, 90]) {
      const a = rad(d), c = Math.cos(a), s = Math.sin(a);
      let u0 = Infinity, u1 = -Infinity, v0 = Infinity, v1 = -Infinity;
      for (const [x, y] of P) {
        const u = (x - cx) * c + (y - cy) * s, v = -(x - cx) * s + (y - cy) * c;
        if (u < u0) u0 = u; if (u > u1) u1 = u; if (v < v0) v0 = v; if (v > v1) v1 = v;
      }
      const w = Math.max((u1 - u0) * (1 + 2 * pad), (v1 - v0) * (1 + 2 * pad) * A, 1e-7);
      const score = w * (d === 0 ? 1 : 1.12);
      if (!best || score < best.score) {
        const mu = (u0 + u1) / 2, mv = (v0 + v1) / 2;
        best = { score, w, ang: d, cx: cx + mu * c - mv * s, cy: cy + mu * s + mv * c };
      }
    }
    return { cx: best.cx, cy: best.cy, w: best.w, ang: best.ang };
  };

  const info = (v, A) => {
    const h = v.w / A, a = rad(v.ang), c = Math.cos(a), s = Math.sin(a);
    const m = 2 * Math.PI * R * Math.cos(rad(inv(v.cx, v.cy)[0]));
    const esq = [[-1, -1], [1, -1], [1, 1], [-1, 1]].map(([su, sv]) => { const u = (su * v.w) / 2, w2 = (sv * h) / 2; return inv(v.cx + u * c - w2 * s, v.cy + u * s + w2 * c); });
    return { centro: inv(v.cx, v.cy), anchoKm: (v.w * m) / 1000, altoKm: (h * m) / 1000, giro: v.ang, esq };
  };

  const img = new Map();
  const tile = (z, x, y) => {
    const k = z + '/' + x + '/' + y;
    if (!img.has(k)) img.set(k, new Promise((res) => { const im = new Image(); im.crossOrigin = 'anonymous'; im.onload = () => res(im); im.onerror = () => res(null); im.src = 'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/' + k + '.png'; }));
    return img.get(k);
  };

  const PAL = { blanco: [240, 236, 228], negro: [70, 70, 74] };
  const AGUA = [118, 160, 214];
  const sombras = new Map();
  const sombrear = (im, z, ty, mapa) => {
    const cv = document.createElement('canvas'); cv.width = cv.height = 256;
    const g = cv.getContext('2d', { willReadFrequently: true });
    g.drawImage(im, 0, 0);
    const id = g.getImageData(0, 0, 256, 256), d = id.data, e = new Float32Array(65536);
    for (let i = 0, j = 0; i < 65536; i++, j += 4) e[i] = d[j] * 256 + d[j + 1] + d[j + 2] / 256 - 32768;
    const n = 2 ** z, lat = inv(0, (ty + 0.5) / n)[0];
    const mpp = (2 * Math.PI * R * Math.cos(rad(lat))) / (256 * n);
    const ex = Math.max(1, Math.min(3.5, 1 + (13 - z) * 0.35));
    const f = ex / (2 * mpp), base = PAL[mapa] || PAL.blanco, negro = mapa === 'negro';
    for (let y = 0; y < 256; y++) {
      const ya = (y ? y - 1 : y) * 256, yb = (y < 255 ? y + 1 : y) * 256, fy = y && y < 255 ? f : 2 * f;
      for (let x = 0; x < 256; x++) {
        const i = y * 256 + x, j = i * 4;
        if (e[i] <= 0) { d[j] = AGUA[0]; d[j + 1] = AGUA[1]; d[j + 2] = AGUA[2]; d[j + 3] = 255; continue; }
        const fx = x && x < 255 ? f : 2 * f;
        const gx = (e[x < 255 ? i + 1 : i] - e[x ? i - 1 : i]) * fx, gy = (e[yb + x] - e[ya + x]) * fy;
        const s = (0.5 * gx + 0.5 * gy + 0.7071) / Math.sqrt(gx * gx + gy * gy + 1);
        const v = negro ? Math.max(0.55, Math.min(1.75, 1 + 1.7 * (s - 0.7071))) : Math.max(0.52, Math.min(1.05, 0.95 + 0.85 * (s - 0.7071)));
        d[j] = Math.min(255, base[0] * v); d[j + 1] = Math.min(255, base[1] * v); d[j + 2] = Math.min(255, base[2] * v); d[j + 3] = 255;
      }
    }
    g.putImageData(id, 0, 0);
    return cv;
  };
  const tileSombreado = (z, x, y, mapa) => {
    const k = z + '/' + x + '/' + y + '/' + mapa;
    if (!sombras.has(k)) sombras.set(k, tile(z, x, y).then((im) => { if (!im) return null; try { return sombrear(im, z, y, mapa); } catch (e) { return null; } }));
    return sombras.get(k);
  };

  const fondo = (mapa) => (mapa === 'negro' ? '#46464A' : '#ECE8E1');

  const vacio = (cv, txt, mapa) => {
    const c = cv.getContext('2d'), W = cv.width, H = cv.height;
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.fillStyle = fondo(mapa); c.fillRect(0, 0, W, H);
    c.strokeStyle = mapa === 'negro' ? 'rgba(255,255,255,.14)' : 'rgba(138,147,163,.35)'; c.lineWidth = Math.max(1, W / 400);
    for (let i = 1; i < 10; i++) { c.beginPath(); c.ellipse(W * 0.5, H * 0.55, W * 0.06 * i, H * 0.07 * i, -0.3, 0, Math.PI * 2); c.stroke(); }
    c.fillStyle = mapa === 'negro' ? '#D3D8E0' : '#4F596A'; c.textAlign = 'center'; c.textBaseline = 'middle';
    c.font = '500 ' + Math.max(11, Math.round(W / 24)) + 'px ' + (getComputedStyle(document.documentElement).getPropertyValue('--at-mono').trim() || 'monospace');
    c.fillText(txt, W / 2, H / 2);
  };

  const render = async (cv, pts, v, o) => {
    const W = cv.width, H = cv.height, tok = (cv._tok = (cv._tok || 0) + 1);
    const w = v.w, h = (w * H) / W, k = W / w, a = rad(v.ang), c = Math.cos(a), s = Math.sin(a);
    const rr = 0.5 * Math.hypot(w, h);
    let z = Math.max(1, Math.min(14, Math.ceil(Math.log2(W / (w * 256))))), n, tx0, tx1, ty0, ty1;
    for (;;) {
      n = 2 ** z;
      tx0 = Math.floor((v.cx - rr) * n); tx1 = Math.floor((v.cx + rr) * n);
      ty0 = Math.max(0, Math.floor((v.cy - rr) * n)); ty1 = Math.min(n - 1, Math.floor((v.cy + rr) * n));
      if ((tx1 - tx0 + 1) * (ty1 - ty0 + 1) <= 30 || z <= 1) break;
      z--;
    }
    const jobs = [];
    for (let ty = ty0; ty <= ty1; ty++) for (let tx = tx0; tx <= tx1; tx++) jobs.push(tileSombreado(z, ((tx % n) + n) % n, ty, o.mapa).then((t) => ({ t, tx, ty })));
    const res = await Promise.all(jobs);
    if (cv._tok !== tok) return null;
    const ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.fillStyle = fondo(o.mapa); ctx.fillRect(0, 0, W, H);
    ctx.setTransform(k * c, -k * s, k * s, k * c, W / 2 - k * (c * v.cx + s * v.cy), H / 2 - k * (-s * v.cx + c * v.cy));
    ctx.imageSmoothingQuality = 'high';
    let ok = true;
    const ov = 0.8 / (256 * n);
    for (const r of res) { if (!r.t) { ok = false; continue; } ctx.drawImage(r.t, r.tx / n, r.ty / n, 1 / n + ov, 1 / n + ov); }
    const P = proy(pts), lw = Math.max(1.4, (o.lineMM * W) / o.mapMM);
    ctx.lineJoin = 'round'; ctx.lineCap = 'round';
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.4)'; ctx.shadowBlur = lw * 0.9; ctx.shadowOffsetX = lw * 0.3; ctx.shadowOffsetY = lw * 0.45;
    ctx.strokeStyle = o.color; ctx.lineWidth = lw / k; ctx.beginPath();
    P.forEach(([x, y], i) => (i ? ctx.lineTo(x, y) : ctx.moveTo(x, y)));
    ctx.stroke(); ctx.restore();
    const dot = (p, col, borde) => { ctx.beginPath(); ctx.arc(p[0], p[1], (lw * 1.5) / k, 0, Math.PI * 2); ctx.fillStyle = col; ctx.fill(); ctx.lineWidth = (lw * 0.45) / k; ctx.strokeStyle = borde; ctx.stroke(); };
    const claro = /^#(f|e)/i.test(o.color);
    dot(P[0], o.color, claro ? '#1A1A1A' : '#FFFFFF');
    dot(P[P.length - 1], o.mapa === 'negro' ? '#F2EFE8' : '#0D1B2E', o.mapa === 'negro' ? '#1A1A1A' : '#FFFFFF');
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    return { ok };
  };

  window.ATMapa = { v: 3, parseGPX, stats, simplify, encode, mejorVista, info, render, vacio };
})();
